import React, { FC } from 'react'

import { DeclarationFormLayoutProps } from '../../../../layouts/DeclarationFormLayout'
import { ActionButtonProps } from '../../../ActionButton'

import * as SC from './styled'

export type CompletedProps = {
  className?: string
  formLayout: DeclarationFormLayoutProps
  title: string
  text: string
  button: ActionButtonProps
}

const Completed: FC<CompletedProps> = (props) => {
  const { className, formLayout, title, text, button } = props

  return (
    <SC.Container className={className}>
      <SC.FormLayout {...formLayout}>
        <SC.Content>
          <SC.Title>{title}</SC.Title>
          <SC.Text>{text}</SC.Text>
          <SC.Button {...button} />
        </SC.Content>
      </SC.FormLayout>
    </SC.Container>
  )
}

export default Completed
